import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import DownloadFormA from "../FormA/DownloadFormA.component";
import { getEmployeeByID } from "app/_services/UserManagement/EmployeeService";
import { employeeFormAFields, initialEmployeeFormA } from "./Constant";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";

function DownloadEmployeeFormA() {
  const { id } = useParams();

  const [data, setData] = useState({
    ...initialEmployeeFormA,
  });

  useEffect(() => {
    if (!id) return;

    getEmployeeByID(id).then((response) => {
      if (!response?.data) return;
      const employeeData = response.data.employees || {};
      setData((prev) => ({
        ...prev,
        ...employeeData,
        startDateAtMines: employeeData.startDateAtMines?.slice(0, 10) || "",
        dateOfJoining: employeeData.dateOfJoining?.slice(0, 10) || "",
        dateOfSeparation: employeeData.dateOfSeparation?.slice(0, 10) || "",
        siteType: employeeData?.ehsSite?.siteType || "",
        mineName: employeeData?.ehsSite?.name || "",
        mineCode: employeeData?.ehsSite?.mineCode || "",
        fullName: `${employeeData.firstName || ""}  ${employeeData.middleName || ""} ${
          employeeData.lastName || ""
        }`,
        ...(employeeData.employeeFormA || {}),
        profilePicture: employeeData.employeeFormA?.profilePicture
          ? `${URL_CONFIG.IMG_URL}${employeeData.employeeFormA?.profilePicture}`
          : "",
        refresherCertificateDate:
          (employeeData?.refresherCertificateDate &&
            DDMMYYYYFormat(employeeData?.refresherCertificateDate)) ||
          "NA",
        refresherCertificateNumber: employeeData?.refresherCertificateNumber || "NA",
        initialTrainingCertificateDate:
          (employeeData?.initialTrainingCertificateDate &&
            DDMMYYYYFormat(employeeData?.initialTrainingCertificateDate)) ||
          "NA",
        initialTrainingCertificateNumber:
          employeeData?.initialTrainingCertificateNumber || "NA",
        dob: (employeeData?.dob && DDMMYYYYFormat(employeeData?.dob)) || "",
        startDateAtMines:
          (employeeData?.startDateAtMines &&
            DDMMYYYYFormat(employeeData?.startDateAtMines)) ||
          "",
        dateOfJoining:
          (employeeData?.dateOfJoining && DDMMYYYYFormat(employeeData?.dateOfJoining)) ||
          "",
        fitnessCertificatePmeDate:
          (employeeData?.fitnessCertificatePmeDate &&
            DDMMYYYYFormat(employeeData?.fitnessCertificatePmeDate)) ||
          (employeeData?.lastPMEDate && DDMMYYYYFormat(employeeData?.lastPMEDate)) ||
          "NA",
        fitnessCertificatePmeNumber:
          employeeData?.fitnessCertificatePmeNumber ||
          employeeData?.pmeCertificateNo ||
          "NA",
        fitnessCertificateImeDate: employeeData?.fitnessCertificateImeDate || "NA",
        fitnessCertificateImeNumber: employeeData?.fitnessCertificateImeNumber || "NA",
      }));
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Form A Management",
            path: "/health-safety-and-environment/form-a-management",
          },
          { name: "View" },
        ]}
      />
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title mb-0">
            <h3 class="text-capitalize mb-1">Download Employee Form A</h3>
          </Card.Title>
          <DownloadFormA fieldsObj={employeeFormAFields} data={data} />
        </Card.Body>
      </Card>
    </div>
  );
}

export default DownloadEmployeeFormA;
